/**
 * Portfolio / search card cover aspect — keep in sync with:
 * - `PortfolioContent` / `ProjectCard` `aspectRatio="16:9"`
 * - `Thumbnail` padding ratio for `'16:9'` (56.25%)
 * - API project thumbs (`720×405` in `apps/api/config/thumbs.php`)
 *
 * Audio generated cards and cover art use the same 16:9 frame.
 */
export const PROJECT_CARD_ASPECT_RATIO = 16 / 9;
export const PROJECT_CARD_ASPECT_LABEL = '16:9';

/** @deprecated Audio cards use PROJECT_CARD_ASPECT_RATIO (16:9). */
export const PROJECT_CARD_ASPECT_SQUARE = 1;

/** In-form live card preview width (px). */
export const PROJECT_CARD_PREVIEW_WIDTH = 320;

/** Rendered thumbnail at 2× the ~320×180 card image area. */
export const PROJECT_CARD_THUMB_2X_WIDTH = 640;
export const PROJECT_CARD_THUMB_2X_HEIGHT = 360;
